var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPictoWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50002 0.416672C3.5971 0.416672 0.416687 3.59709 0.416687 7.50001C0.416687 11.4029 3.5971 14.5833 7.50002 14.5833C11.4029 14.5833 14.5834 11.4029 14.5834 7.50001C14.5834 3.59709 11.4029 0.416672 7.50002 0.416672ZM7.50002 13.1667C4.37627 13.1667 1.83335 10.6238 1.83335 7.50001C1.83335 4.37626 4.37627 1.83334 7.50002 1.83334C10.6238 1.83334 13.1667 4.37626 13.1667 7.50001C13.1667 10.6238 10.6238 13.1667 7.50002 13.1667ZM9.62502 7.50001C9.62502 8.67584 8.67585 9.62501 7.50002 9.62501C6.32419 9.62501 5.37502 8.67584 5.37502 7.50001C5.37502 6.32417 6.32419 5.37501 7.50002 5.37501C8.67585 5.37501 9.62502 6.32417 9.62502 7.50001Z",
    fill: "#1CD4FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoWeb);
export default __webpack_public_path__ + "static/media/picto-web.ec330e80976270bd510b2bd5d92ff4aa.svg";
export { ForwardRef as ReactComponent };